import React from 'react'
import { FormattedMessage, FormattedDate } from 'react-intl'
import PropTypes from 'prop-types'
import { API } from 'aws-amplify'
import { Link } from 'react-router-dom'
import Utils from '../../lib/utils'

class MembershipBlock extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      printedOnCard: null,
      axessStatusLoading: true
    }
  }

  componentDidMount = () => {
    this.mapPrintedOnCardToState()
  }

  keycardStatusMsg = () => {
    const { props, state } = this
    const { bookingOrders, membership } = props
    const nextUpcomingBookingOrder = bookingOrders && bookingOrders.length > 0 && bookingOrders
      .sort((a, b) => new Date(a.booking.dateStart).getTime() > new Date(b.booking.dateStart).getTime() ? 1 : -1)
      .find(order => (
        new Date(order.booking.dateEnd).getTime() > new Date().getTime()) 
          && !order.booking.cancelledAt
      )

    const startDateTime = nextUpcomingBookingOrder && new Date(nextUpcomingBookingOrder.booking.dateStart)

    return state.axessStatusLoading && (
      <div className="text-grey">...</div>
    ) || state.printedOnCard && !membership.passLost && (
      <div className="text-grey italic">
        <FormattedMessage id="dashboard.link.keycardIssued" defaultMessage="Keycard issued" />
      </div>
    ) || startDateTime && Utils.isToday(startDateTime) && (
      <Link to={`/bookings/${nextUpcomingBookingOrder.bookingId}`} className="text-grass">
        <FormattedMessage id="dashboard.link.pickupKeycard" defaultMessage="Pick up keycard" />
        <svg className="w-3 h-3 ml-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="qrcode" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z" /></svg>
      </Link>
    ) || (
        <div className="text-grey italic">
          <FormattedMessage id="dashboard.link.keycardAwaitingBarcode" defaultMessage="QR ready on date of booking" />
        </div>
      )
  }

  enrichBookingOrderWithAxessStatus = async bookingOrder => {
    try {
      const axessStatus = await API.get("cphill", `/axess/prepaidTicketStatus/${bookingOrder.axess.orderNo}/${bookingOrder.axess.journalNo}`)
      return {
        ...bookingOrder,
        axess: {
          ...bookingOrder.axess,
          axessStatus
        }
      }
    } catch (error) {
      return bookingOrder
    }
  }

  mapPrintedOnCardToState = async () => {
    const { bookingOrders } = this.props
    const bookingOrdersEnrichedWithAxessStatus = await Promise.all(
      bookingOrders &&
      bookingOrders
        .filter(b => b.axess && b.axess.orderNo)
        .map(bookingOrder => this.enrichBookingOrderWithAxessStatus(bookingOrder))
    )
    const bookingOrderOnCard = bookingOrdersEnrichedWithAxessStatus
      .filter(bookingOrder =>
        bookingOrder.axess &&
        bookingOrder.axess.axessStatus &&
        bookingOrder.axess.axessStatus.status === 'completed'
      )
      .pop()

    const printedOnCard = bookingOrderOnCard &&
      bookingOrderOnCard.axess &&
      bookingOrderOnCard.axess.serialNo &&
      bookingOrderOnCard.axess.status !== 'AWAITING_CARD_ISSUANCE' &&
      `684-10-${bookingOrderOnCard.axess.serialNo}`

    this.setState({ printedOnCard, axessStatusLoading: false })
  }

  render = () => {
    const { props, state } = this
    const { skus, participant, membership, index } = props
    const weekdayPrice = (skus && skus.length > 0) && Utils.getSkuPrice(membership.type, 'hourRateWeekdaysSkuId', skus)
    const weekendPrice = (skus && skus.length > 0) && Utils.getSkuPrice(membership.type, 'hourRateWeekendsSkuId', skus)

    return (
      <div className={`bg-white shadow-md border-t border-grey-lighter ${index % 2 === 0 ? 'md:mr-2' : 'md:ml-2'}`}>
        <div className="p-3 pb-2">
          <h3 className="text-harbor uppercase mb-1 truncate">
            {participant && `${participant.firstName} ${participant.lastName}`}
          </h3>
          <h3 className="text-grass uppercase whitespace-no-wrap truncate">
            <FormattedMessage id={`passTypes.${membership.type}`} defaultMessage="PassType" />
            ,&nbsp;
            <FormattedMessage id={`passTypes.${membership.ageCategory || 'adult'}`} defaultMessage={membership.ageCategory || 'adult'} />
          </h3>
          <div className="text-sm mt-4">
            <FormattedMessage id="dashboard.memberships.skiHour" defaultMessage="Pr. hour" />
            {weekdayPrice !== weekendPrice && (
              <span className="text-xs text-grey-darker">
                &nbsp;
                <FormattedMessage id="dashboard.weekday" defaultMessage="weekday" />
                /
                <FormattedMessage id="dashboard.weekend" defaultMessage="weekend" />
              </span>
            )}
          </div>
          <div className="flex items-end w-full">
            <div>
              <div className="flex items-end">
                <h1 className="mb-0 pb-0 leading-none">
                  {weekdayPrice}
                </h1>
                <div className="text-xs">
                  &nbsp;DKK
                </div>
              </div>
            </div>
            {weekdayPrice !== weekendPrice && (
              <div className="flex items-end ml-2">
                <h1 className="mb-0 pb-0 leading-none">
                  {weekendPrice}
                </h1>
                <div className="text-xs">
                  &nbsp;DKK
                </div>
              </div>
            )}

            <div className="text-right flex-grow">
              <div className="text-xs text-grey-darker">
                <div>
                  {!Utils.isHourly(membership.type) ? (<>
                    <FormattedMessage id="dashboard.memberships.expires" defaultMessage="Expires:" />
                    &nbsp;
                    <FormattedDate value={membership.dateEnd} year='numeric' month='short' day='numeric' />
                  </>) : (<>&nbsp;</>)}
                </div>
                {state.printedOnCard || state.axessStatusLoading && !membership.passLost && (
                  <>...</>
                ) || (
                    <div className="text-xs text-grey-darker italic">
                      <FormattedMessage id="dashboard.memberships.keycardNotIssued" defaultMessage="Card not picked up" />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        <div className="p-3 border-t text-right uppercase font-bold text-base">
          {this.keycardStatusMsg()}
        </div>
      </div>

    )
  }
}

MembershipBlock.propTypes = {
  bookingOrders: PropTypes.instanceOf(Array).isRequired,
  membership: PropTypes.shape({
    membership: PropTypes.object
  }).isRequired,
  participant: PropTypes.shape({
    participant: PropTypes.object
  }).isRequired,
  skus: PropTypes.instanceOf(Array),
  index: PropTypes.number.isRequired
}

MembershipBlock.defaultProps = {
  skus: []
}

export default MembershipBlock